import { AppraiserFlagType } from './AppraiserFlagType';

export const AppraiserFlagTypeOptions = [
    {
        id: AppraiserFlagType.Retired,
        name: 'Retired',
    },
    {
        id: AppraiserFlagType.Preferred,
        name: 'Preferred',
    },
    {
        id: AppraiserFlagType.Issue,
        name: 'Issue',
    },
    {
        id: AppraiserFlagType.Blacklisted,
        name: 'Blacklisted',
    },
];
